/**
 * L2-R1: moved to @miq/platform (services/user-locale.service.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform'.
 *
 * The `getUserInfoWithSSO()` dependency was leaf-split into
 * @miq/platform/lib/services/sso-user-info.ts and takes the API base URL as an argument
 * (provided via the APP_API_BASE_URL token) so the library never imports `@env`.
 */
export {
  UserLocaleService,
  HK_COUNTRIES,
  EMEA_UK_COUNTRIES,
  EMEA_UK_NETHERLANDS_COUNTRIES,
  EMEA_CE_COUNTRIES,
  EMEA_CE_RETAIL_COUNTRIES,
  EUR_UK_COUNTRIES,
  EUR_CE_COUNTRIES,
  EUR_COUNTRIES,
  MEA_COUNTRIES,
} from '@miq/platform';
